import { formatMoney, normalizeMoney } from '../../../shared/money/exact-money.js';
const ACTION_PERMISSIONS = {approve:'transaction.approve',decline:'transaction.reject',refresh:'transaction.view',record_manual_evidence:'transaction.approve'};
export function paymentActions(execution, hasPermission) {
  if(execution?.version!=='2' || typeof hasPermission!=='function') return [];
  return Object.entries(ACTION_PERMISSIONS).filter(([action,permission])=>execution.allowedActions?.includes(action) && hasPermission(permission)).map(([action])=>action);
}
export function evidencePayload(execution, form) {
  const money=execution?.requestedMoney;
  const amount=String(form.amount ?? '').trim();
  const scale=money?.scale;
  if(!Number.isInteger(scale) || scale<0 || scale>36 || !/^\d+(\.\d+)?$/.test(amount)) throw Error('Enter the exact transferred amount.');
  const [whole,fraction='']=amount.split('.');
  if(fraction.length>scale && /[1-9]/.test(fraction.slice(scale))) throw Error('The amount has too many decimal places.');
  const units=(whole+fraction.slice(0,scale).padEnd(scale,'0')).replace(/^0+(?=\d)/,'');
  if(!form.sourceReference?.trim() || !['settled','no_effect'].includes(form.outcome)) throw Error('Enter the transfer reference and outcome.');
  return {sourceReference:form.sourceReference.trim(),amountUnits:units,asset:money.asset,scale,outcome:form.outcome};
}

export function formatPaymentMoney(money, locale) {
  const value = normalizeMoney(money);
  return value && !value.units.startsWith('-') ? formatMoney(value, locale) : '—';
}
